import { render, staticRenderFns } from "./AddChannelSidebarContent.vue?vue&type=template&id=8da63bfe&scoped=true"
import script from "./AddChannelSidebarContent.vue?vue&type=script&lang=js"
export * from "./AddChannelSidebarContent.vue?vue&type=script&lang=js"
import style0 from "./AddChannelSidebarContent.vue?vue&type=style&index=0&id=8da63bfe&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da63bfe",
  null
  
)

export default component.exports